/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { CloneReportDefinitionMutationResponse, CloneReportDefinitionPathParams, CloneReportDefinition404 } from "../models/CloneReportDefinition";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { cloneReportDefinition } from "../axios/cloneReportDefinition";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const cloneReportDefinitionMutationKey = () => ["audit-reports-api", { url: '/report-definitions/:id/clone' }] as const

export type CloneReportDefinitionMutationKey = ReturnType<typeof cloneReportDefinitionMutationKey>

export function cloneReportDefinitionMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = cloneReportDefinitionMutationKey()
        return mutationOptions<CloneReportDefinitionMutationResponse, ResponseErrorConfig<CloneReportDefinition404>, {id: CloneReportDefinitionPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return cloneReportDefinition(id, config)
          },
        })

}

/**
 * @description Creates a copy of an existing report definition. The cloned definition uses the same blueprint version as the source and is not set as default.
 * @summary Clone report definition
 * {@link /report-definitions/:id/clone}
 */
export function useCloneReportDefinition<TContext>(options: 
{
  mutation?: UseMutationOptions<CloneReportDefinitionMutationResponse, ResponseErrorConfig<CloneReportDefinition404>, {id: CloneReportDefinitionPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? cloneReportDefinitionMutationKey()

          const baseOptions = cloneReportDefinitionMutationOptions(config) as UseMutationOptions<CloneReportDefinitionMutationResponse, ResponseErrorConfig<CloneReportDefinition404>, {id: CloneReportDefinitionPathParams["id"]}, TContext>
          

          return useMutation<CloneReportDefinitionMutationResponse, ResponseErrorConfig<CloneReportDefinition404>, {id: CloneReportDefinitionPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CloneReportDefinitionMutationResponse, ResponseErrorConfig<CloneReportDefinition404>, {id: CloneReportDefinitionPathParams["id"]}, TContext>
      
}